import React from "react";
import { useState } from "react";
import "components/generales/Styles.css";
import MyMoneyLoggedOut from 'components/MyMoney/MyMoneyLoggedOut'
import Formulario from "components/inicio/Formulario";
import "pages/inicio/StylesInicio.css";

const Registro = () => {
  const [registroUsuarios, setRegistroUsuarios] = useState([]);

  return (
    <>
      <section>
        <div className="imagenContenedor imagenInicio"></div>
        <div className="contenidoContenedor">
          <div className="formularioContenedor">
            <MyMoneyLoggedOut />
            <h2>Registro</h2>
            <Formulario
              registroUsuarios={registroUsuarios}
              setRegistroUsuarios={setRegistroUsuarios}
            />
            <div className="formulario-input">
              <p>
                ¿Ya tienes una cuenta? <a href="/">Inicia sesión</a>{" "}
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Registro;
